import { createForm, getData } from "../helpers";

class ChangeTelemetered extends HTMLDivElement {
    connectedCallback() {
        this.firstElementChild.addEventListener("click", (e) => {
            const Target = e.target;
            createForm(getData(Target, "data-url"), {
                telemetered: Target.checked ? 1 : 0,
            });
        });
    }
}

window.customElements.define("change-telemetered", ChangeTelemetered, {
    extends: "div",
});
